import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useControlled } from '../../../../internal/hooks';
/**
 * Хук-контроллер, возвращающий подготовленное состояние
 * и обработчики событий для отдельных частей Tooltip-компонент
 *
 * Этот контроллер реализует поведение открытия/закрытия по клику
 *
 * @export
 * @param {IBaseTooltipProps} props
 * @returns
 */
export function useClickController(props) {
  const {
    children,
    onClose,
    onOpen
  } = props;
  const childrenRef = React.useRef(null);
  const handleChildrenRef = useForkRef(children.ref, childrenRef);
  const [open, setOpen] = useControlled({
    controlled: props.open,
    default: false
  });
  const handleClose = React.useCallback(() => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);
  const handleClick = e => {
    const childrenProps = children.props;
    if (childrenProps.onClick) {
      childrenProps.onClick(e);
    }
    if (e.defaultPrevented) {
      return;
    }
    e.stopPropagation();
    const nextState = !open;
    setOpen(nextState);
    if (nextState) {
      if (onOpen) {
        onOpen();
      }
    } else {
      if (onClose) {
        onClose();
      }
    }
  };
  const childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onClick: handleClick,
    ref: handleChildrenRef
  });
  return {
    childrenRef,
    childrenProps,
    open,
    handleClose
  };
}